import { Link } from "react-router-dom";

export default function BondingLiquidHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1A1A1A] to-[#2d2d2d] text-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text Content */}
          <div className="space-y-6">
            <p className="text-white/60 uppercase tracking-widest text-xs font-medium">
              EVERYDAY · CONTRACTOR GRADE · ELITE PRO SERIES
            </p>
            <h1 className="text-5xl lg:text-6xl font-bold font-['Montserrat'] leading-tight">
              Bonding Liquid
            </h1>
            <p className="text-lg text-white/80 leading-relaxed max-w-xl">
              A high-performance bonding agent that bonds new concrete, plaster, and screed to old surfaces. Improves adhesion and reduces shrinkage and cracking.
            </p>
            <div className="pt-4">
              <Link
                to="/contact"
                className="inline-block bg-[#F2C612] text-black px-8 py-3 rounded-lg font-semibold hover:bg-[#d4ae10] transition-colors whitespace-nowrap cursor-pointer"
              >
                Get in Touch
              </Link>
            </div>
          </div>

          {/* Right: Product Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-md h-[400px] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/e979337ea2bae95e15be184daa76cce2.png"
                alt="Best Bonding Liquid - Three Tier Range"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}